export default __webpack_public_path__ + "static/media/torch.9b39bcdd.gif";